import { NgModule } from '@angular/core';
import { LayoutComponent } from './layout/layout.component';

import { HeaderNavComponent } from './header-nav/header-nav.component';
import { DefaultComponent } from '../pages/default/default.component';
import { AsideNavComponent } from './aside-nav/aside-nav.component';
import { FooterComponent } from './footer/footer.component';
import { QuickSidebarComponent } from './quick-sidebar/quick-sidebar.component';
import { ScrollTopComponent } from './scroll-top/scroll-top.component';
import { TooltipsComponent } from './tooltips/tooltips.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HrefPreventDefaultDirective } from '../../_directives/href-prevent-default.directive';
import { UnwrapTagDirective } from '../../_directives/unwrap-tag.directive';
import { FormGroupComponent, FormGroupErrorComponent, FormGroupMetronicComponent } from './custom-component/FormGroupComponent';
import { PageComponent } from './custom-component/PageComponent';
import { PortletComponent, PortletFooterLeftComponent, PortletFooterRightComponent } from './custom-component/portlet.component';
import { GenericComponent } from "./custom-component/generic-component";
import { PageTableComponent } from "./custom-component/page-table.component";
import { CrudTableComponent } from "./custom-component/crud-table.component";
import { QRCodeModule } from 'angularx-qrcode';
import { EditorModule } from '@tinymce/tinymce-angular';
//import { PayPal } from 'braintree-web';

import {
    CalendarModule,
    DataTableModule,
    AccordionModule,
    ButtonModule,
    CheckboxModule,
    ChipsModule,
    CodeHighlighterModule,
    ColorPickerModule,
    InputMaskModule,
    FieldsetModule,
    GrowlModule,
    InputTextModule,
    MultiSelectModule,
    InputTextareaModule,
    PanelModule,
    RadioButtonModule,
    SelectButtonModule,
    SplitButtonModule,
    DropdownModule,
    TabViewModule,
    DataListModule,
    DialogModule,
    SpinnerModule,
    TreeModule,
    ContextMenuModule,
    SharedModule,
    OrderListModule,
    InputSwitchModule,
    FileUploadModule,
    ListboxModule,
    ChartModule,
    BlockUIModule,
    ProgressSpinnerModule,
    AutoCompleteModule,
    ToolbarModule,
    SelectItem,
    KeyFilterModule,
    SliderModule,
    PickListModule
} from 'primeng/primeng';


@NgModule({
    declarations: [
        LayoutComponent,

        HeaderNavComponent,
        DefaultComponent,
        AsideNavComponent,
        FooterComponent,
        QuickSidebarComponent,
        ScrollTopComponent,
        TooltipsComponent,
        HrefPreventDefaultDirective,
        UnwrapTagDirective,
        FormGroupComponent,
        FormGroupMetronicComponent,
        FormGroupErrorComponent,
        PageComponent,
        PortletComponent,
        PortletFooterLeftComponent,
        PortletFooterRightComponent,
        GenericComponent,
        PageTableComponent,
        CrudTableComponent,
    ],
    exports: [
        LayoutComponent,

        HeaderNavComponent,
        DefaultComponent,
        AsideNavComponent,
        FooterComponent,
        QuickSidebarComponent,
        ScrollTopComponent,
        TooltipsComponent,
        HrefPreventDefaultDirective,
        FormGroupComponent,
        FormGroupMetronicComponent,
        FormGroupErrorComponent,
        PageComponent,
        PortletComponent,
        PortletFooterLeftComponent,
        PortletFooterRightComponent,
        GenericComponent,
        PageTableComponent,
        QRCodeModule,
        //braintree,
        //PayPal,
        CrudTableComponent,
        // primeng modules
        CalendarModule,
        DataTableModule,
        ButtonModule,
        CheckboxModule,
        ChipsModule,
        CodeHighlighterModule,
        ColorPickerModule,
        InputMaskModule,
        GrowlModule,
        InputTextModule,
        MultiSelectModule,
        RadioButtonModule,
        SelectButtonModule,
        SplitButtonModule,
        TabViewModule,
        AccordionModule,
        PanelModule,
        FieldsetModule,
        InputTextareaModule,
        DropdownModule,
        DataListModule,
        DialogModule,
        SpinnerModule,
        TreeModule,
        ContextMenuModule,
        EditorModule,
        SharedModule,
        OrderListModule,
        InputSwitchModule,
        FileUploadModule,
        ListboxModule,
        ChartModule,
        BlockUIModule,
        ProgressSpinnerModule,
        AutoCompleteModule,
        ToolbarModule,
        KeyFilterModule,
        SliderModule,
        PickListModule
    ],
    imports: [
        CommonModule,
        RouterModule,
        // primeng modules
        CalendarModule,
        DataTableModule,
        ButtonModule,
        CheckboxModule,
        ChipsModule,
        CodeHighlighterModule,
        ColorPickerModule,
        InputMaskModule,
        GrowlModule,
        InputTextModule,
        MultiSelectModule,
        RadioButtonModule,
        SelectButtonModule,
        SplitButtonModule,
        TabViewModule,
        AccordionModule,
        PanelModule,
        FieldsetModule,
        InputTextareaModule,
        DropdownModule,
        DataListModule,
        DialogModule,
        SpinnerModule,
        TreeModule,
        ContextMenuModule,
        EditorModule,
        SharedModule,
        OrderListModule,
        InputSwitchModule,
        FileUploadModule,
        ListboxModule,
        ChartModule,
        BlockUIModule,
        ProgressSpinnerModule,
        AutoCompleteModule,
        ToolbarModule,
        KeyFilterModule,
        SliderModule,
        PickListModule
    ]
})
export class LayoutModule {
}


// WEBPACK FOOTER //
// ./src/app/theme/layouts/layout.module.ts